import api from '../api';
import EditableInput from './EditableInput';

function Profile({user, setUser}) {
	const updateProfile = (key, value, extra) => {
		api.updateProfile(user.token, {
			[key]: value
		})
		.then( ({data}) => {
			if(data.status === 'SUCCESS'){
				let s = {...user};
				s.user[key] = value;
				setUser(s);
				localStorage.setItem('user', JSON.stringify(s));
			}else{
				throw new Error('Could not update profile');
			}
		})
	}
	return (
		<div className="page">
			<h3>Profile Details</h3>
			<div className="text__muted">Changes are saved automatically</div>
			<div className="card">
				<div className="form__group">
					<label>Email</label>
					<div className="flex flex__row">
						<div className="input__wrap flex" disabled>
							<input type="text" placeholder="Type here..." value={user.user.email} />
							<span className="focus"></span>
						</div>
						{/* <div className="btn btn__primary-soft">
							<span className="material-icons">
								content_copy
							</span>
						</div> */}
					</div>
				</div>
				<div className="form__group">
					<label>Name</label>
					<EditableInput nonEmpty type="text" characterCount={100} item="name" startValue={user.user.name} updateAction={updateProfile} />
				</div>
				<div className="form__group">
					<label>Surname</label>
					<EditableInput nonEmpty type="text" characterCount={100} item="surname" startValue={user.user.surname} updateAction={updateProfile} />
				</div>
				<div className="form__group">
					<label>Linkedin Profile</label>
					<EditableInput type="text" characterCount={100} item="linkedin" startValue={user.user?.linkedin} updateAction={updateProfile} />
				</div>
				<div className="form__group">
					<label>Website</label>
					<EditableInput type="text" characterCount={100} item="website" startValue={user.user?.website} updateAction={updateProfile} />
				</div>
			</div>
		</div>
	)
}

export default Profile